import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { makeGetIsSuspendedSelector } from "~/store/selectors/selector.configOptions";
import { makeIsLoggedUserOwnerSelector } from "~/store/selectors/selector.users";

export const RequireNotSuspended = ({ children }) => {
  const getIsSuspended = useMemo(() => {
    return makeGetIsSuspendedSelector();
  }, []);
  const getIsLoggedUserOwner = useMemo(() => makeIsLoggedUserOwnerSelector(), []);
  const isAccountSuspended = useSelector(getIsSuspended);
  const isLoggedUserOwner = useSelector(getIsLoggedUserOwner);

  return !isAccountSuspended ? children : <Navigate to={isLoggedUserOwner ? "/subscription" : "/suspended"} />;
};

RequireNotSuspended.propTypes = {
  children: PropTypes.any,
};
